import type { Institution, Plan } from '@faceup/utils'
import { createContext, type ReactNode } from 'react'
import type { PhoneInputProps } from 'react-phone-input-2'
import type { PagesTranslationItems, PagesTranslationVariants } from '../hooks'

type UiProviderContextProps = {
  linkExternalConfirm?: {
    confirmRedirectMessageTitle?: string
    confirmRedirectMessageContent?: string
    redirectOkButton?: string
    redirectCancelButton?: string
  }
  inputPhone?: Pick<PhoneInputProps, 'searchPlaceholder' | 'localization' | 'searchNotFound'>
  inputCopyable?: {
    onCopySuccess?: () => void
    copy: string
  }
  pages?: {
    translations: Record<PagesTranslationVariants, Record<PagesTranslationItems, string>>
    isDefaultForm: boolean
    setIsDefaultForm: (isDefaultForm: boolean) => void

    mother: {
      type: Institution | null
      plan: Plan | null
      isTesting: boolean | null
    }
  }
  buttonConfirm?: {
    confirm: string
    cancel: string
  }
  multiSelect?: {
    allSelected: string
  }
  theme?: {
    colors?: {
      primary?: string
      dark?: string
    }
  }
  table?: {
    shown: string
    search: string
    reset: string
    ok: string
  }
  dropzoneImage?: {
    upload: string
  }
  editableSortableList?: {
    addItem: string
    delete: string
  }
  paginator?: {
    totalRows: (totalRows: number) => string
  }
  upload?: {
    text: string
  }
  viewMore?: {
    viewMore: string
    viewLess: string
  }
  attachmentList?: {
    download: string
  }
  moreOptions?: {
    label: string
  }
  audioPlayer?: {
    label: string
    play: string
    pause: string
    playDisabled: string
    download: string
    remove: string
  }
}

export type UiProviderProps = {
  children: ReactNode
} & UiProviderContextProps

export const UiContext = createContext<UiProviderContextProps>({})

export const UiProvider = ({ children, ...props }: UiProviderProps) => (
  <UiContext.Provider value={props}>{children}</UiContext.Provider>
)
